import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class SiderTopic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.title}>
                {content.map((item, index) => (
                    <a key={index} href={item.url} target="_blank" rel={rel}>
                        {item.title}
                    </a>
                ))}
            </div>
        );
    }
}

export default errorBoundary(SiderTopic);
